import { render, staticRenderFns } from "./BulkUpdateRouteForm.vue?vue&type=template&id=0a008b64"
import script from "./BulkUpdateRouteForm.vue?vue&type=script&lang=js"
export * from "./BulkUpdateRouteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports